import TemplateView from '../../../../TemplateView'

export default class DelimiterItem extends TemplateView {
    templateHtml() {
        return '<div class="delimiter"></div>'
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/itemsFilter/DelimiterItem.js